import type { GridProps as MuiGridProps } from '@mui/material/Grid/Grid';
import MuiGrid from '@mui/material/Grid/Grid';

export type GridProps = MuiGridProps;

export const Grid = MuiGrid;
